var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"scanner-container"}},[_c('canvas',{staticClass:"drawingBuffer",staticStyle:{"position":"absolute","width":"80%"}}),_c('video',{staticStyle:{"width":"80%"},attrs:{"preload":"auto"}})])
}]

export { render, staticRenderFns }